import { FC } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import {
    addProduct,
    removeProduct
} from "@/redux/modules/api/data/wishlist/wishlist.module";
import { getWishlists } from "@/redux/modules/api/data/wishlist/wishlist.selectors";
import { TrackingProductModel } from "@/services/tracking/types/trackingProduct.model";

import WishlistButton from "./WishlistButton.component";

export interface WishlistButtonContainerProps {
    sku: string;
    product: TrackingProductModel;
    withReload?: boolean;
    className?: string;
    iconSize?: string;
    label?: (isProductInWishlist: boolean) => string;
    labelClassName?: string;
    disabled?: boolean;
}

export const WishlistButtonContainer: FC<WishlistButtonContainerProps> = ({
    sku,
    product,
    withReload,
    className,
    iconSize,
    label,
    labelClassName,
    disabled = false
}) => {
    const wishlists = useSelector(getWishlists);
    const dispatch = useThunkDispatch();

    const addToWishlist = () => {
        return dispatch(addProduct(sku, product));
    };

    const removeFromWishlist = () => {
        return dispatch(removeProduct(sku, withReload));
    };

    return (
        <WishlistButton
            className={className}
            addToWishlist={addToWishlist}
            removeFromWishlist={removeFromWishlist}
            label={label}
            labelClassName={labelClassName}
            sku={sku}
            wishlists={wishlists}
            iconSize={iconSize}
            disabled={disabled}
        />
    );
};
